import React from 'react';
import ReactDOM from 'react-dom';
import ContentTabs from "../../../ContentTabs/components/ContentTabs";

const elem = document.getElementById("educationProducts")

let data = [];

if (elem.dataset.showprojectors.trim().toLowerCase() === 'true') {
    data.push({
        backgroundUrl: "/images/solutions/education/Projection_770x700.jpg",
        iconUrl: "/images/solutions/projectors.svg",
        title: i18njs["Solutions.Projectors"],
        mainText: i18njs["Solutions.ProjectorsMainTextEducation"],
        buttonText: i18njs["Solutions.MoreInfo"],
        buttonUrl: "/products/projectors",
        tabIconUrl: "/images/solutions/projectors.svg"
    });
}

if (elem.dataset.showifpd.trim().toLowerCase() === 'true') {
    data.push({
        backgroundUrl: "/images/solutions/education/IFPD_770.jpg",
        iconUrl: "/images/solutions/IFPD.svg",
        title: i18njs["Solutions.InteractiveDisplays"],
        mainText: i18njs["Solutions.InteractiveDisplaysMainTextEducation"],
        buttonText: i18njs["Solutions.MoreInfo"],
        buttonUrl: "/products/interactive-flat-panel-displays",
        tabIconUrl: "/images/solutions/IFPD.svg"
    });
}

if (elem.dataset.showprofdisp.trim().toLowerCase() === 'true') {
    data.push({
        backgroundUrl: "/images/solutions/education/Professional_Displays_770.jpg",
        iconUrl: "/images/solutions/Professional_Displays.svg",
        title: i18njs["Solutions.ProfessionalDisplays"],
        mainText: i18njs["Solutions.ProfessionalDisplaysMainText"],
        buttonText: i18njs["Solutions.MoreInfo"],
        buttonUrl: "/products/professional-lcd-displays",
        tabIconUrl: "/images/solutions/Professional_Displays.svg"
    });
}

if (elem.dataset.showled.trim().toLowerCase() === 'true') {
    data.push({
        backgroundUrl: "/images/solutions/education/LED_770.jpg",
        iconUrl: "/images/solutions/LED.svg",
        title: i18njs["Solutions.LedDisplays"],
        mainText: i18njs["Solutions.LedDisplaysMainText"],
        buttonText: i18njs["Solutions.MoreInfo"],
        buttonUrl: "/led-displays",
        tabIconUrl: "/images/solutions/LED.svg"
    });
}

if (elem.dataset.showaccs.trim().toLowerCase() === 'true') {
    data.push({
        backgroundUrl: "/images/solutions/education/Accessories_770.jpg",
        iconUrl: "/images/solutions/Accessories.svg",
        title: i18njs["Solutions.Accessories"],
        mainText: i18njs["Solutions.AccessoriesMainText"],
        buttonText: i18njs["Solutions.MoreInfo"],
        buttonUrl: "/products/accessories",
        tabIconUrl: "/images/solutions/Accessories.svg"
    });
}

ReactDOM.render(
    <ContentTabs data={data}></ContentTabs>,
    elem
);
